<template>

	<div class="row" ref="orderContainer">

		<div class="col-md-10 offset-2 page-account--title">
			<h1 class="h3">{{ showingOrder ? 'Order number #'+id : $__('profile.order.history.title') }}</h1>
		</div>
		<div class="col-md-2 sidebar">
			<div class="sidebar-wrapper menu">
				<slot></slot>
			</div>
		</div>
		<div class="col-md-10 content">
			<p class="label">{{ showingOrder ? $__('order.text.information') : $__('profile.order.history.text') }}</p>
			<div class="alert alert-success" v-if="reOrdered">
				<p>{{ $__('order.message.reordered') | locale(`#${reOrdered}`) }}</p>
			</div>
			<lupit-ordersingle v-if="showingOrder" :order="order" @closeOrder="historyBack" @orderAgain="reOrder(order.id, order.details)"></lupit-ordersingle>
			<div v-else>
			<div class="orders-table" v-if="laravelData.data && laravelData.data.length && loaded">
				<div class="table">
					<div class="table-head">
						<div class="cell-head" v-text="$__('profile.history.open')"></div>
						<div class="cell-head" v-text="$__('profile.history.reference')"></div>
						<div class="cell-head" v-text="$__('profile.history.date')"></div>
						<div class="cell-head" v-text="$__('profile.history.total')"></div>
						<div class="cell-head" v-text="$__('profile.history.payment')"></div>
						<div class="cell-head" v-text="$__('profile.history.status')"></div>
						<div class="cell-head" v-text="$__('profile.history.invoice')"></div>
						<div class="cell-head"></div>
					</div>

					<div v-for="order in laravelData.data" :key="order.id">
						<div class="table-row">
							<div class="cell-row open"><button class="btn btn-plain" :data-item="`order-${order.id}`"><svg class="ticon"><use xlink:href="/images/icons.svg#icon-chevron-down"></use></svg></button></div>
							<div class="cell-row reference" v-text="order.id"></div>
							<div class="cell-row">{{ order.created_at | formatDate }}</div>
							<div class="cell-row">{{ order.order_sum | formatCurrency }}</div>
							<div class="cell-row">-</div>
							<div class="cell-row status"><span :class="`status state-${order.status}`">{{ order.status | orderStatus }}</span></div>
							<div class="cell-row"><a href="#" title="View" @click.prevent="showOrder(order.id, order)" v-text="$__('profile.history.view')"></a></div>
							<div class="cell-row"><button class="btn btn-primary" @click="reOrder(order.id, order.details)" v-text="$__('profile.history.reorder')"></button></div>
						</div>
						<div class="items-ordered" :data-target="`order-${order.id}`">
							<p v-text="$__('profile.order.ordered.items')"></p>
							<div class="items-ordered--wrapper">
								<div class="item" v-for="product in order.details" :key="product.id">
									<img v-if="product.product && product.product.picture" loading="lazy" :src="`/storage/${product.product.picture}`" class="img-fluid" :title="product.product_title" :alt="product.product_title" width="80" height="80">
									<h6 class="h-alter" v-text="product.product_title"></h6>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div v-else-if="loaded && (!laravelData.data || !laravelData.data.length)" v-html="$__('profile.order.noorders')">

			</div>
			<lupit-pagination :show-disabled="true" :data="laravelData" @pagination-change-page="getResults">
				<span class="d-flex align-items-center" slot="prev-nav"><svg class="ticon ticon-180"><use xlink:href="/images/icons.svg#icon-chevron-right"></use></svg> {{ $__('page.pagination.prev') }}</span>
				<span class="d-flex align-items-center" slot="next-nav">{{ $__('page.pagination.next') }} <svg class="ticon"><use xlink:href="/images/icons.svg#icon-chevron-right"></use></svg></span>
			</lupit-pagination>
		</div>

		</div>

	</div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

Vue.filter('orderStatus', function(value) {
	if (value) {
		const statuses = ['Pending', 'Processing', 'Completed', 'Cancelled'];
		return statuses[value];
	}
});

Vue.filter('locale', function(value, message) {
	return value.replace('%%', message);
	// if (message, value) {
	// 	return message.replace('%%', value);
	// }
});

export default {
	name: "OrderHistory",
	props: {

	},
	data() {
		return {
			laravelData: {},
			fullPage: false,
			loaded: false,
			reOrdered: false,
			showingOrder: false,
			order: {}
		}
	},
	components: {
		Loading
	},
	mounted() {
		this.getResults();
	},

	methods: {
		getResults(page = 1) {
			let loader = this.$loading.show({
				container: this.fullPage ? null : this.$refs.orderContainer,
				loader: 'dots',
				canCancel: false,
				color: '#E6007E',
				opacity: 0.2
			});
			axios.get('/profile/orders?page=' + page)
				.then(response => {
					this.laravelData = response.data;
					this.loaded = true;
					loader.hide();
				});
			this.reOrdered = false;
		},
		historyBack() {
			this.showingOrder = false;
		},
		showOrder(id, order) {
			this.id = id;
			this.order = order;
			this.showingOrder = true;
		},
		reOrder(id, order) {
			order.forEach(product => {
				this.$store.dispatch('cart/addToCart', {
					product: product.id,
					amount: parseInt(product.amount)
				}).then(res => {

				});
			});
			this.reOrdered = id;
		},
	}

}
</script>
